import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ViewEncapsulation,
} from '@angular/core';

import { PageInfoComponent } from '../page-info';

import { CountryInfoTextService } from '../../services/country-info-text.service';
import { BreakpointService } from '../../../../core/services/breakpoint.service';
import { ScrollToIdService } from '../../../../core/services/scroll-to-id.service';

import { CountryInfoPageMobileComponent } from '../../layout/mobile/country-info-page-mobile/country-info-page-mobile.component';
import { CountryInfoPageDesktopComponent } from '../../layout/desktop/country-info-page-desktop/country-info-page-desktop.component';

@Component({
    selector: 'app-country-info-page',
    templateUrl: './country-info-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CountryInfoPageDesktopComponent, CountryInfoPageMobileComponent],
    providers: [CountryInfoTextService]
})
export class CountryInfoPageComponent extends PageInfoComponent {
  public menuOpened: boolean[] = [];

  constructor(
    protected cdr: ChangeDetectorRef,
    protected scrollToIdService: ScrollToIdService,
    protected countryInfoTextService: CountryInfoTextService,
    protected readonly breakpointService: BreakpointService,
  ) {
    super(cdr, scrollToIdService);
  }
}
